webpackJsonp([90],{

/***/ 157:
/***/ (function(module, exports) {

module.exports = {
  methods: {
    hello: function hello() {
      console.log('hello from mixin!');
    },
    quotationMargin: function quotationMargin(price, cost) {
      return price / (cost - 1);
    },
    formatFloat: function formatFloat(amount, places) {
      return parseFloat(amount).toFixed(places);
    },
    grossMargin: function grossMargin(data, type) {
      switch (type) {
        case 1:
          return data.price ? ((parseFloat(data.price) / parseFloat(data.cost) - 1) * 100).toFixed(2) + '%' : null;
          break;
        case 2:
          var manufacturing_price = parseFloat(data.cost_setup) + parseFloat(data.cost_etest_tooling);
          var sell_price = parseFloat(data.price_etest_tooling) + parseFloat(data.price_setup);
          return sell_price ? ((sell_price / manufacturing_price - 1) * 100).toFixed(2) + '%' : null;
          break;
      }
    }
  }
};

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Routes
 */

// components
var Backlog = function Backlog(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(197)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var BacklogOld = function BacklogOld(resolve) {
  return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(289)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NotFound = function NotFound(resolve) {
  return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(280)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Forbidden = function Forbidden(resolve) {
  return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(282)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(283)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Otp = function Otp(resolve) {
  return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(284)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ChangePassword = function ChangePassword(resolve) {
  return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(281)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var SsoLogin = function SsoLogin(resolve) {
  return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(286)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

module.exports = [{ name: 'register',
  path: '/register', component: function component(resolve) {
    return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(285)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, { path: '/login', component: Login }, { path: '/sso-callback', component: SsoLogin }, { path: '/', redirect: '/backlog' }, { path: '/backlog', component: Backlog,
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: false,
      hq_top: true,
      purchaser: true,
      qc: false,
      r_and_d: true,
      client_p: true,
      hq_warehouse: true,
      auditor: false
    }
  }
}, { path: '/backlog-new', component: BacklogOld,
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: false,
      hq_top: true,
      purchaser: true,
      qc: false,
      r_and_d: true,
      client_p: true,
      hq_warehouse: true,
      auditor: false
    }
  }
}, { path: '/change-password', component: ChangePassword,
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/settings',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(351)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, {
  path: '/clients',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(302)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    name: 'edit-clients',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }]
}, {
  path: '/items',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(313)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(312)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(309)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    name: 'edit-items',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(311)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: true,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'duplicate/:id',
    name: 'duplicate-item',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(310)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }]
}, {
  path: '/quotations',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(316)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(314)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    name: 'edit-quotations',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(315)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }]
}, {
  path: '/vendors',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(321)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(320)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(318)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    name: 'edit-vendors',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(319)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }]
}, {
  path: '/purchasers',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(335)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(334)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(332)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'edit/:id',
    name: 'edit-purchasers',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(333)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: '/users',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(360)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(359)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: false,
        client: false,
        hq_top: true,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(357)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: false,
        client: false,
        hq_top: true,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    name: 'edit-users',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(358)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: false,
        client: false,
        hq_top: true,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }]
}, {
  path: '/backlog',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(293)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: false,
      hq_top: true,
      purchaser: true,
      qc: false,
      r_and_d: true,
      client_p: true,
      hq_warehouse: true,
      auditor: false
    }
  },
  children: [{
    path: '/backlog/sales-order',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(197)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: true,
        qc: false,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/backlog/sales-order/add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(290)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/backlog/sales-order/edit/:id',
    name: 'edit-sales-order',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(291)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/backlog/sales-order/log/:id',
    name: 'logs-sales-order',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/som/edit/:id',
    name: 'som-edit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(355)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/sub-som/edit/:id',
    name: 'som-edit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(356)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: '/documents/edit/:id',
    name: 'documents-edit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(306)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/rfq/edit/:id',
    name: 'rfq-edit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(341)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/backlog/commercial-offers',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(18)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }]
}, {
  path: '/purchase-order',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(331)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: false,
      hq_top: true,
      purchaser: true,
      qc: false,
      r_and_d: false,
      client_p: true,
      auditor: false
    }
  },
  children: [{
    path: '/purchase-order/edit/:id',
    name: 'edit-purchase-order',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(329)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: true,
        qc: false,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: '/purchase-order/log/:id',
    name: 'edit-purchase-log',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(330)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }]
}, {
  path: '/buyersheet',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/buyersheet/purchase-order/create',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/buyersheet/purchase-order/edit/:id',
    name: 'edit-purchase-order-buyer',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, { path: '/auth-commercial-offers', component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(18)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: true,
      r_and_d: true,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/client/commercial-offers', component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(18)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: false,
      supervisor: false,
      client: true,
      hq_top: true,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: true,
      auditor: false
    }
  }
}, { path: '/samples-documents', component: function component(resolve) {
    return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(342)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { path: '/delivery-details', component: function component(resolve) {
    return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { path: '/delivery-details/:id', component: function component(resolve) {
    return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { path: '/qr-management/:id/audit', component: function component(resolve) {
    return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(337)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { path: '/samples', component: function component(resolve) {
    return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(350)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(346)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'delivery-details',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(345)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'inspection-results',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(347)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'proforma/add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(348)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'proforma/edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(349)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: false,
        purchaser: true,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'arrival-details/add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(343)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        purchaser: true,
        client: false,
        hq_top: false,
        qc: false,
        r_and_d: false,
        client_p: false,
        auditor: false
      }
    }
  }, {
    path: 'arrival-details/edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(344)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        purchaser: true,
        client: false,
        hq_top: false,
        qc: false,
        r_and_d: true,
        client_p: false,
        auditor: false
      }
    }
  }]
}, { path: '/qr-management', component: function component(resolve) {
    return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(340)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(339)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(336)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(338)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }]
}, { path: '/purchase-order-sheets', component: function component(resolve) {
    return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  } }, { path: '/commercial-offers', component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(18)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  } }, { name: 'add lot number', path: '/lot-numbers/add', component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(202)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { name: 'edit lot number', path: '/lot-numbers/edit/:id', component: function component(resolve) {
    return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(202)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { path: '*', component: NotFound }, { path: '/forbidden', component: Forbidden,
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: true
    }
  }
}, { path: '/otp', component: Otp,
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      hq_warehouse: true,
      auditor: true
    }
  }
}, {
  path: '/payment-plan',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(328)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(326)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(327)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }]
}, {
  path: '/arrival-details',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(279)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(287)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(288)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        auditor: false
      }
    }
  }]
}, {
  path: '/logistics',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(325)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(323)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        hq_warehouse: true,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(324)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: true,
        hq_top: true,
        purchaser: true,
        qc: true,
        r_and_d: true,
        client_p: true,
        hq_warehouse: true,
        auditor: false
      }
    }
  }]
}, {
  path: '/so_log',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(354)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'add',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(352)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }, {
    path: 'edit/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(353)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: {
        admin: true,
        supervisor: true,
        client: false,
        hq_top: true,
        purchaser: false,
        qc: false,
        r_and_d: false,
        client_p: true,
        auditor: false
      }
    }
  }]
}, {
  path: '/item-logs/:id',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(322)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, {
  path: '/exports/:id',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(308)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, {
  path: '/file/download',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(307)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: true,
      client: true,
      hq_top: true,
      purchaser: true,
      qc: true,
      r_and_d: true,
      client_p: true,
      auditor: false
    }
  }
}, { path: '/documents-archive', component: function component(resolve) {
    return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(305)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: true
    }
  }
}, { path: '/documents-archive/services/create', component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/services/edit/:id', component: function component(resolve) {
    return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/documents/create', component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/documents/edit/:id', component: function component(resolve) {
    return __webpack_require__.e/* require */(4/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/credit-notes/create', component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(198)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/credit-notes/edit/:id', component: function component(resolve) {
    return __webpack_require__.e/* require */(6/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(198)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/debit-notes/create', component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}, { path: '/documents-archive/debit-notes/edit/:id', component: function component(resolve) {
    return __webpack_require__.e/* require */(5/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: {
      admin: true,
      supervisor: false,
      client: false,
      hq_top: false,
      purchaser: false,
      qc: false,
      r_and_d: false,
      client_p: false,
      auditor: false
    }
  }
}];

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(274),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(272),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(269),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_forms_purchase_order_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popup_forms_purchase_order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__popup_forms_purchase_order_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup_forms_hq_delivery_date_change_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popup_forms_hq_delivery_date_change_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__popup_forms_hq_delivery_date_change_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			showPurchaseOrderModal: false,
			showHqDeliveryDateChangeModal: false
		};
	},
	methods: {
		logout: function logout() {
			this.$http.post("https://stg-backlog.teltonika.hk/api" + '/user/logout?token=' + this.$cookies.get('teltonika_session')).then(function (response) {
				// response
			}, function (response) {
				// fail
			});
			this.$cookies.remove('teltonika_session');
			this.$cookies.remove('teltonika_verified');
			this.$cookies.remove('teltonika_session_content');
			this.$router.go('/login');
		}
	},
	components: {
		Modal: __WEBPACK_IMPORTED_MODULE_2__Modal_vue___default.a,
		'purchase-order': __WEBPACK_IMPORTED_MODULE_0__popup_forms_purchase_order_vue___default.a,
		'hq-delivery-date-change': __WEBPACK_IMPORTED_MODULE_1__popup_forms_hq_delivery_date_change_vue___default.a
	}

});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    modalSize: {
      type: String
    },
    modalType: {
      type: String
    }
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['load'],
	data: function data() {
		return {
			contacts: [],
			pagination: [],
			submitting: false,
			loading: false,
			limit: 10,
			page: 1,
			name: '',
			email: '',
			search: '',
			selected: {}
		};
	},

	components: {
		'el-pagination': __WEBPACK_IMPORTED_MODULE_1_element_ui__["Pagination"]
	},
	watch: {
		'limit': function limit() {
			this.get();
		}
	},
	methods: {
		fetchPaginate: function fetchPaginate(page) {
			if (this.page != page) {
				this.page = page;
				this.get();
			}
		},
		handleSizeChange: function handleSizeChange(size) {
			this.limit = size;
		},
		create: function create() {
			var _this = this;

			this.$validator.validateAll('form-create').then(function (success) {
				if (success) {
					_this.submitting = true;

					_this.$http.post("https://stg-backlog.teltonika.hk/api" + '/contacts?token=' + _this.$cookies.get('teltonika_session'), {
						name: _this.name,
						email: _this.email
					}).then(function (response) {
						_this.$notify({
							title: 'Success',
							message: 'Contact added',
							type: 'success',
							duration: 3000
						});
						_this.submitting = false;
						_this.clear();
						_this.get();
					}, function (response) {
						if (response.status == 422) {
							_this.$notify({
								title: 'Error',
								message: response.statusText,
								type: 'error',
								duration: 3000
							});

							var vm = _this;
							$.each(response.body, function (key, val) {
								vm.errors.add(key, val[0]);
							});
						} else {
							_this.$notify({
								title: 'Error',
								message: 'Something went wrong!',
								type: 'error',
								duration: 3000
							});
						}

						_this.submitting = false;
					});
				}
			});
		},
		update: function update() {
			var _this2 = this;

			this.$validator.validateAll('form-create').then(function (success) {
				if (success) {
					_this2.submitting = true;

					_this2.$http.put("https://stg-backlog.teltonika.hk/api" + '/contacts/' + _this2.selected.id + '?token=' + _this2.$cookies.get('teltonika_session'), {
						name: _this2.name,
						email: _this2.email,
						id: _this2.selected.id
					}).then(function (response) {
						_this2.$notify({
							title: 'Success',
							message: 'Contact updated',
							type: 'success',
							duration: 3000
						});
						_this2.submitting = false;
						_this2.selected = {};
						_this2.clear();
						_this2.get();
					}, function (response) {
						if (response.status == 422) {
							_this2.$notify({
								title: 'Error',
								message: response.statusText,
								type: 'error',
								duration: 3000
							});

							var vm = _this2;
							$.each(response.body, function (key, val) {
								vm.errors.add(key, val[0]);
							});
						} else {
							_this2.$notify({
								title: 'Error',
								message: 'Something went wrong!',
								type: 'error',
								duration: 3000
							});
						}

						_this2.submitting = false;
					});
				}
			});
		},
		clear: function clear() {
			this.name = '';
			this.email = '';
		},
		get: function get() {
			var _this3 = this;

			var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.page;

			this.loading = true;

			var filters = '';

			filters += '&limit=' + this.limit;

			filters += '&page=' + page;

			if (this.search !== '') {
				filters += '&search=' + this.search;
			}

			this.$http.get("https://stg-backlog.teltonika.hk/api" + '/contacts?token=' + this.$cookies.get('teltonika_session') + filters).then(function (response) {
				_this3.contacts = response.body.data;
				_this3.pagination = response.body;
				_this3.loading = false;
			}, function (response) {
				console.log(response);
				_this3.loading = false;
			});
		},
		remove: function remove(item) {
			var vm = this;
			__WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes'
			}).then(function () {
				vm.submitting = true;
				vm.$http.delete("https://stg-backlog.teltonika.hk/api" + '/contacts/' + item.id + '?token=' + vm.$cookies.get('teltonika_session')).then(function (response) {
					vm.$notify({
						title: 'Success',
						message: 'Contact Deleted',
						type: 'success'
					});
					vm.submitting = false;
					vm.get();
				}, function (response) {
					vm.submitting = false;
					if (response.data.message) {
						vm.$notify({
							title: 'Error',
							message: response.data.message,
							type: 'error'
						});
					}
				});
			}, function (dismiss) {});
		},
		edit: function edit(item) {
			this.selected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
			this.name = this.selected.name;
			this.email = this.selected.email;
		},
		cancel: function cancel(item) {
			this.selected = {};
			this.clear();
		}
	},
	created: function created() {
		this.get();
	}
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_forms_contact_list_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_forms_contact_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__popup_forms_contact_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            items: [],
            pagination: [],
            sales_order: {},
            sales_orders: [],
            sales_order_items: [],
            prev_sales_order: [],
            email_person: {},
            contacts: [],
            contact_options: [],
            sales_order_items_all: false,
            search: '',
            status: 'selection',
            limit: 5,
            page: 1,
            show_contacts_list: false,
            comments: '',
            vendors: [],
            item_manufacturer_filters: [],
            vendor_filters: [],
            item_manufacturers: [],
            unformat_etd_date_range: '',
            responsible_person: {},
            sort_dir: null,
            sort_by: null,
            shipping_methods: [],
            shipping_method: [],
            delivery_codes: [],
            delivery_code: []
        };
    },

    components: {
        Money: __WEBPACK_IMPORTED_MODULE_6_v_money__["Money"],
        'el-pagination': __WEBPACK_IMPORTED_MODULE_2_element_ui__["Pagination"],
        'contact-list': __WEBPACK_IMPORTED_MODULE_4__popup_forms_contact_list_vue___default.a,
        Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a,
        Modal: __WEBPACK_IMPORTED_MODULE_3__Modal_vue___default.a
    },
    watch: {
        'sales_order': function sales_order(val, prev) {
            this.getSalesOrderItems(1);
            this.getVendors();
            this.getItemManufacturers();
        },
        'limit': function limit() {
            this.getSalesOrderItems();
        },
        'status': function status(val) {
            if (val == 'contact-sharing') {
                this.getContacts();
            }
        },
        unformat_etd_date_range: function unformat_etd_date_range() {
            this.getSalesOrderItems(1);
        },
        vendor_filters: function vendor_filters() {
            this.getSalesOrderItems(1);
        },
        item_manufacturer_filters: function item_manufacturer_filters() {
            this.getSalesOrderItems(1);
        },
        shipping_method: function shipping_method() {
            this.getSalesOrderItems(1);
        },
        delivery_code: function delivery_code() {
            this.getSalesOrderItems(1);
        }
    },
    computed: {
        selected_ids: function selected_ids() {
            return this.items.map(function (a) {
                return a.id;
            });
        },
        transformedManufacturerFilter: function transformedManufacturerFilter() {
            return this.item_manufacturer_filters.map(function (manufacturer) {
                return manufacturer.name;
            });
        },
        transformedVendorFilter: function transformedVendorFilter() {
            return this.vendor_filters.map(function (vendor) {
                return vendor.id;
            });
        },
        etd_date_range: function etd_date_range(data) {
            return data.unformat_etd_date_range && {
                from: data.unformat_etd_date_range[0] ? moment(data.unformat_etd_date_range[0]).format('YYYY-MM-DD') : '',
                to: data.unformat_etd_date_range[1] ? moment(data.unformat_etd_date_range[1]).format('YYYY-MM-DD') : ''
            };
        },
        transformedShippingMethodFilter: function transformedShippingMethodFilter() {
            return this.shipping_method.map(function (row) {
                return row.id;
            });
        },
        transformedDeliveryCodeFilter: function transformedDeliveryCodeFilter() {
            return this.delivery_code.map(function (row) {
                return row.id;
            });
        }
    },
    methods: {
        statusClass: function statusClass(row, index) {
            var class_name = '';

            if (row !== null) {
                var status = row.order_status.toLowerCase();

                class_name += status;

                if (status == 'confirmed' && row.direct_shipment == 1 || status == 'confirmed' && this.$root.userRole == 'purchaser') {
                    class_name += ' green-estimated-td-vendor';
                }

                if (status == 'confirmed' && row.direct_shipment != 1 && row.estimated_td_date && this.$root.userRole != 'purchaser') {
                    class_name += ' green-estimated-td-hk';
                }

                if (row.quotation.item.weight_grams > 0) {
                    class_name += ' has-weight-grams';
                } else {
                    class_name += ' has-no-weight-grams';
                }
            }

            return class_name;
        },
        removeContact: function removeContact(row, index) {
            this.contacts.splice(index, 1);
        },
        addContact: function addContact() {

            var vm = this;

            if (vm.email_person.id === undefined) {
                vm.$notify({
                    title: 'Error',
                    message: 'Select person',
                    type: 'error',
                    duration: 3000
                });

                return false;
            }

            var added = false;

            $.each(this.contacts, function (key, val) {
                if (vm.email_person.id == val.id) {
                    vm.$notify({
                        title: 'Error',
                        message: 'Contact already added',
                        type: 'error',
                        duration: 3000
                    });

                    added = true;
                    return false;
                }
            });

            if (!added) {
                this.contacts.push(this.email_person);
            }
        },
        getSalesOrders: function getSalesOrders() {
            var _this = this;

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/sales-order-logs/completed?token=' + this.$cookies.get('teltonika_session')).then(function (response) {
                _this.sales_orders = response.body;
            }, function (response) {
                console.log(response);
            });
        },
        getSalesOrderItems: function getSalesOrderItems() {
            var _this2 = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.page;

            this.sales_order_items_all = true;

            var filters = '';

            var manufacturers = this.transformedManufacturerFilter.length ? '&manufacturers=' + this.transformedManufacturerFilter.join('|') : '';
            var vendors = this.transformedVendorFilter.length ? '&vendors=' + this.transformedVendorFilter.toString() : '';
            var etd_date = this.etd_date_range ? '&etd_date_from=' + this.etd_date_range.from + '&etd_date_to=' + this.etd_date_range.to : '';
            var salesOrder = this.sales_order && this.sales_order.id ? '&sales_order_id=' + this.sales_order.id : '';
            var shippingMethods = this.transformedShippingMethodFilter.length ? '&shipping_method_ids=' + this.transformedShippingMethodFilter.toString() : '';
            var deliveryCodes = this.transformedDeliveryCodeFilter.length ? '&client_delivery_address_ids=' + this.transformedDeliveryCodeFilter.toString() : '';

            filters += '&limit=' + this.limit;

            filters += '&page=' + page;

            if (this.search !== '') {
                filters += '&search=' + this.search;
            }

            if (this.sort_by != null) {
                filters += '&sort_by=' + this.sort_by;
            }

            if (this.sort_dir != null) {
                filters += '&sort_dir=' + this.sort_dir;
            }

            filters += vendors + manufacturers + etd_date + salesOrder + shippingMethods + deliveryCodes;
            //console.log(filters);
            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/sales-order-logs/search/completed?token=' + this.$cookies.get('teltonika_session') + filters).then(function (response) {
                //console.log(response)
                _this2.sales_order_items = response.body.data;
                _this2.pagination = response.body;
                _this2.sales_order_items_all = false;
            }, function (response) {
                console.log(response);
                _this2.sales_order_items_all = false;
            });
        },
        clearItems: function clearItems() {
            this.items = [];
            this.sales_order_items = [];
        },
        addItem: function addItem(item) {
            this.items.push(item);
        },
        removeItem: function removeItem(index) {
            this.items.splice(index, 1);
        },
        isAdded: function isAdded(item) {
            if (this.selected_ids.includes(item.id)) {
                return true;
            }

            return false;
        },
        fetchPaginate: function fetchPaginate(page) {
            if (this.page != page) {
                this.page = page;
                this.getSalesOrderItems();
            }
        },
        handleSizeChange: function handleSizeChange(size) {
            this.limit = size;
        },
        getContacts: function getContacts() {
            var _this3 = this;

            this.$root.getRequest('/user/usertype?user_type=hq_top,client_p').then(function (response) {
                _this3.contact_options = response.body.items;
            }, function (response) {
                console.log(response);
            });
        },
        contactsDisplayed: function contactsDisplayed(visible) {
            if (!visible) {
                this.getContacts();
            }
        },
        next: function next() {
            var _this4 = this;

            this.$http.post("https://stg-backlog.teltonika.hk/api" + '/som?token=' + this.$cookies.get('teltonika_session'), {
                responsible_person_id: this.responsible_person.id,
                items: this.items,
                contacts: this.contacts,
                comments: this.comments
            }).then(function (response) {

                _this4.$notify({
                    title: 'Success',
                    message: 'Items added',
                    type: 'success',
                    duration: 3000
                });

                var route = _this4.$router.resolve({ path: '/som/edit/' + response.body.data.id });
                window.open(route.href, '_blank');
                location.reload();
            });
        },
        getVendors: function getVendors() {
            var _this5 = this;

            var filters = '';

            var salesOrder = this.sales_order && this.sales_order.id ? '&sales_order_id=' + this.sales_order.id : '';
            filters += salesOrder;

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/sales-order-logs/completed/vendors?token=' + this.$cookies.get('teltonika_session') + filters).then(function (response) {
                _this5.vendors = response.body;
                var vendor = _this5.getQueryVariable('vendor');

                if (vendor) {
                    for (var i = 0; i < _this5.vendors.length; i++) {
                        if (_this5.vendors[i]['id'] == vendor) {
                            _this5.vendor_filters.push(_this5.vendors[i]);
                            break;
                        }
                    }
                }
            });
        },
        getItemManufacturers: function getItemManufacturers() {
            var _this6 = this;

            var filters = '';

            var salesOrder = this.sales_order && this.sales_order.id ? '&sales_order_id=' + this.sales_order.id : '';
            filters += salesOrder;
            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/sales-order-logs/completed/manufacturers?token=' + this.$cookies.get('teltonika_session') + filters).then(function (response) {
                _this6.item_manufacturers = response.body;
            });
        },
        getQueryVariable: function getQueryVariable(variable) {
            var url = decodeURIComponent(window.location.href),
                url = url.split('?'),
                query = '';
            if (url.length > 1) {
                query = url[1];
            }
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return false;
        },

        sortTable: function sortTable(data) {
            // console.log(data)
            this.sort_by = data.prop;
            this.sort_dir = data.order;
            if (data.order != null) {
                this.sort_dir = data.order == 'ascending' ? 'asc' : 'desc';
            }

            this.getSalesOrderItems(1);
            // console.log(this.sort_by)
            // console.log(this.sort_dir)
        },
        getShippingMethods: function getShippingMethods() {
            var _this7 = this;

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/shipping-method?token=' + this.$cookies.get('teltonika_session')).then(function (response) {
                if (response.status == 200) {
                    _this7.shipping_methods = response.data;
                }
            }, function (response) {
                // fail
            });
        },
        getDeliveryCodes: function getDeliveryCodes() {
            var _this8 = this;

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/salesorder/delivery-codes?token=' + this.$cookies.get('teltonika_session')).then(function (response) {
                if (response.status == 200) {
                    _this8.delivery_codes = response.data;
                }
            }, function (response) {
                // fail
            });
        }
    },
    created: function created() {
        this.responsible_person = this.$root.user;
        this.getSalesOrders();
        this.getVendors();
        this.getItemManufacturers();
        this.getShippingMethods();
        this.getDeliveryCodes();
    }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            vendor: null,
            pending_items: [],
            pending_vendors: [],
            items: [],
            search: "",
            purchase_order_items: [],
            itemsLimit: 5,
            items_pagination: [],
            page: 1,
            tableRequest1: false,
            submitting: false,
            prev_vendor: {},
            requested_td_filter: ''
        };
    },

    components: {
        Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a,
        'el-pagination': __WEBPACK_IMPORTED_MODULE_2_element_ui__["Pagination"]
    },
    computed: {
        selected_ids: function selected_ids() {
            return this.purchase_order_items.map(function (a) {
                return a.id;
            });
        }
    },
    created: function created() {
        this.getPendingItems();
        this.getPendingVendors();
    },

    watch: {
        'vendor': function vendor(val, prev) {
            var self = this;
            if (this.purchase_order_items.length && val != this.prev_vendor) {
                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                    title: 'Are you sure?',
                    text: "There are already selected purchase order items, these will be emptied!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                }).then(function () {
                    self.purchase_order_items = [];
                }, function (dismiss) {
                    self.vendor = prev;
                    self.prev_vendor = self.vendor; // used to track if forced changed
                });
            } else {
                this.getVendorPendingItems(1);
            }
        },
        'itemsLimit': function itemsLimit() {
            this.getVendorPendingItems();
        },
        requested_td_filter: function requested_td_filter() {
            this.getVendorPendingItems(1);
        }
    },
    methods: {
        minusDays: function minusDays(date, subtractDay) {
            return moment(date).subtract(subtractDay, "days").format('YYYY-MM-DD');
        },
        getPendingItems: function getPendingItems() {
            var _this = this;

            var search = '';

            if (this.$root.userRole == 'purchaser') {
                search += 'buyer_id=' + this.$root.user.id + '&';
            }

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/purchase_order/pending/items?' + search + 'token=' + this.$cookies.get('teltonika_session')).then(function (response) {
                _this.pending_items = response.body;
            }, function (response) {
                console.log(response);
            });
        },
        getPendingVendors: function getPendingVendors() {
            var _this2 = this;

            var search = '';

            if (this.$root.userRole == 'purchaser') {
                search += 'buyer_id=' + this.$root.user.id + '&';
            }

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/purchase_order/pending/vendors?' + search + 'token=' + this.$cookies.get('teltonika_session')).then(function (response) {
                _this2.pending_vendors = response.body;
            }, function (response) {});
        },
        getVendorPendingItems: function getVendorPendingItems() {
            var _this3 = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.page;
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.search;

            var filters = '';

            this.tableRequest1 = true;

            filters += '&limit=' + this.itemsLimit;
            filters += '&page=' + page;
            if (search !== '') {
                filters += '&search=' + search;
            }

            filters += '&vendor_id=' + this.vendor.id;

            if (this.$root.userRole == 'purchaser') {
                filters += '&buyer_id=' + this.$root.user.id;
            }

            if (this.requested_td_filter) {
                if (this.requested_td_filter[0]) {
                    filters += '&requested_td_start=' + moment(this.requested_td_filter[0]).format('YYYY-MM-DD') + '&';
                }

                if (this.requested_td_filter[1]) {
                    filters += '&requested_td_end=' + moment(this.requested_td_filter[1]).format('YYYY-MM-DD') + '&';
                }
            }

            this.$http.get("https://stg-backlog.teltonika.hk/api" + '/purchase_order/pending/items?token=' + this.$cookies.get('teltonika_session') + filters).then(function (response) {
                _this3.items = response.body.data;
                _this3.items_pagination = response.body;
                _this3.tableRequest1 = false;
            }, function (response) {});
        },
        addPurchaseItem: function addPurchaseItem(item) {
            this.purchase_order_items.push(item);
        },
        removePurchaseItem: function removePurchaseItem(index) {
            this.purchase_order_items.splice(index, 1);
        },
        isDisabledAdding: function isDisabledAdding(row) {
            if (this.selected_ids.includes(row.id)) {
                return true;
            }

            return false;
        },
        handleSizeChange: function handleSizeChange(size) {
            this.itemsLimit = size;
        },
        fetchPaginate: function fetchPaginate(page) {
            if (this.page != page) {
                this.page = page;
                this.getVendorPendingItems();
            }
        },
        submitPurchaseOrder: function submitPurchaseOrder() {
            var _this4 = this;

            this.submitting = true;
            var formData = {
                vendor_id: this.vendor.id,
                items: this.purchase_order_items,
                user_id: this.$root.user.id
            };
            this.$parent.$emit('close', true);
            this.$http.post("https://stg-backlog.teltonika.hk/api" + '/purchase-order/save?token=' + this.$cookies.get('teltonika_session'), formData).then(function (response) {
                if (response.status == 201) {
                    _this4.submitting = false;
                    _this4.$parent.$emit('close', true);
                    var route = _this4.$router.resolve({ path: '/purchase-order/edit/' + response.body.id });
                    window.open(route.href, '_blank');
                }
            }, function (response) {
                _this4.$notify({
                    title: 'Error',
                    message: 'Something went wrong!',
                    type: 'error',
                    duration: 3000
                });
                _this4.submitting = false;
            });
        }
    }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookies__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__routes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_amount_functions_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_amount_functions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__mixins_amount_functions_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_filters__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_textarea_autosize__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_quill_editor__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_chartjs_plugin_datalabels__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Header_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Footer_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Footer_vue__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_quill_editor___default.a);

// configure language
__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_en___default.a);
__webpack_require__(162);

var config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'inputs ', //default fields
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true

    // We want to apply VueResource and VueRouter
    // to our Vue instance
};__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */], config);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_11__mixins_amount_functions_js___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_textarea_autosize__["default"]);

// Global components



var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_6__routes_js___default.a, // short for routes: routes
    linkActiveClass: 'active',
    history: true
});

// protect routes. Allow user which are logged in
router.beforeEach(function (to, from, next) {
    var cookies = __WEBPACK_IMPORTED_MODULE_3_vue_cookies___default.a;

    var user = JSON.parse(cookies.get('teltonika_session_content'));

    if (to.path !== '/login' && to.path !== '/login?error=inactive' && to.name !== 'register' && to.path !== '/commercial-offers' && to.path !== '/sso-callback') {
        // if token is not set redirect to /login
        if (cookies.get('teltonika_session') === null) {
            next({
                path: '/login'
            });
        } else {
            if (to.path !== '/otp' && cookies.get('teltonika_verified') != 'true') {
                next({
                    path: '/otp'
                });
            }
            {
                if (to.path === '/commercial-offers') {
                    next({
                        path: '/commercial-offers'
                    });
                } else {
                    if (to.meta.roles[user.user_type]) {
                        next();
                    } else {
                        next({
                            path: '/forbidden'
                        });
                    }
                }
            }
        }
    } else {
        if (cookies.get('teltonika_session') !== null) {

            var path = 'otp';

            if (cookies.get('teltonika_verified') == 'true') {
                path = 'items';
                if (user.user_type == 'hq_warehouse') {
                    path = 'backlog';
                }
                if (user.user_type == 'auditor') {
                    path = 'documents-archive';
                }
            }

            next({
                path: '/' + path
            });
        } else {
            next();
        }
    }
    if (!to.query.page) {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('html, body').animate({
            scrollTop: 0
        }, 'slow');
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
    next(function (response) {
        var token = "";
        if (token = response.headers.get('authorization')) {
            if (token != __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cookies.get('teltonika_session')) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cookies.set('teltonika_session', token);
            }
        }
    });
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    data: function data() {
        return {
            newEndpoint: "https://api-staging.teltonika.hk/api/v1",
            user: {},
            quotationRequestUrl: '',
            isEditFromQuotationsPage: false,
            date_picker_options: {
                firstDayOfWeek: 1
            },
            editorOption: {
                modules: {
                    toolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'font': [] }], [{ 'align': [] }]]
                }
            },
            moneyOption: {
                decimal: '.',
                thousands: ',',
                precision: 2,
                masked: false
            },
            numberOption: {
                decimal: '.',
                thousands: ',',
                precision: 0,
                masked: false
            },
            moneyOptionPrecisionOne: {
                decimal: '.',
                thousands: ',',
                precision: 1,
                masked: false
            },
            moneyOptionPrecisionThree: {
                decimal: '.',
                thousands: ',',
                precision: 3,
                masked: false
            },
            moneyOptionPrecisionFour: {
                decimal: '.',
                thousands: ',',
                precision: 4,
                masked: false
            },
            moneyOptionPrecisionFive: {
                decimal: '.',
                thousands: ',',
                precision: 5,
                masked: false
            }
        };
    },

    computed: {
        headers: function headers() {
            return {
                'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session')
            };
        },
        userRole: function userRole() {
            var role = this.user ? this.user.user_type : '';
            if (role === 'supervisor') {
                role = 'admin';
            }
            return role;
        },
        user_role: function user_role() {
            return this.user ? this.user.user_type : '';
        },
        isAdmin: function isAdmin() {
            return this.user && this.user.user_type === 'admin';
        },
        anAdmin: function anAdmin() {
            return this.user && this.user.user_type === 'admin';
        },
        isSuperVisor: function isSuperVisor() {
            return this.user && this.user.user_type === 'supervisor';
        },
        isSuperVisorOrAdmin: function isSuperVisorOrAdmin() {
            return this.user && (this.user.user_type === 'supervisor' || this.user.user_type === 'admin');
        },
        isClient: function isClient() {
            return this.user && (this.user.user_type === 'client' || this.user.user_type === 'client_p');
        },
        isHqTop: function isHqTop() {
            return this.user && this.user.user_type === 'hq_top';
        },
        isRandD: function isRandD() {
            //Warehouse
            return this.user && this.user.user_type === 'r_and_d';
        },
        isWarehouse: function isWarehouse() {
            //Warehouse
            return this.isRandD;
        },
        isQc: function isQc() {
            return this.user && this.user.user_type === 'qc';
        },
        isPurchaser: function isPurchaser() {
            return this.user && this.user.user_type === 'purchaser';
        },
        userName: function userName() {
            return this.user ? this.user.name : '';
        },
        isRDOrQC: function isRDOrQC() {
            return this.user && (this.user.user_type == 'r_and_d' || this.user.user_type == 'qc');
        },
        isHQOrClientOrQC: function isHQOrClientOrQC() {
            return this.user && (this.user.user_type === 'hq_top' || this.user.user_type === 'client' || this.user.user_type === 'qc' || this.user.user_type === 'client_p');
        },
        isClientPlus: function isClientPlus() {
            return this.user && this.user.user_type === 'client_p';
        },
        isHQWarehouse: function isHQWarehouse() {
            //Warehouse
            return this.user && this.user.user_type === 'hq_warehouse';
        },
        isAuditor: function isAuditor() {
            return this.user && this.user.user_type === 'auditor';
        },
        isClientOrHqTop: function isClientOrHqTop() {
            return this.isClient || this.isHqTop;
        },
        base_url: function base_url() {
            return "https://stg-backlog.teltonika.hk/api";
        },
        domain: function domain() {
            return "https://stg-backlog.teltonika.hk/";
        }
    },
    components: {
        'app-header': __WEBPACK_IMPORTED_MODULE_16__components_Header_vue___default.a,
        'app-footer': __WEBPACK_IMPORTED_MODULE_17__components_Footer_vue___default.a,
        ChartJsPluginDataLabels: __WEBPACK_IMPORTED_MODULE_15_chartjs_plugin_datalabels___default.a
    },
    watch: {
        '$route.fullPath': function $routeFullPath() {
            // if ($route.fullPath)
            if (this.userRole === 'purchaser' && (this.$route.fullPath.indexOf('/items') || this.$route.fullPath.indexOf('/backlog') || this.$route.fullPath.indexOf('/quotations') || this.$route.fullPath.indexOf('/vendors'))) {
                this.$router.replace(this.$route.fullPath);
            } else {
                if (this.userRole === 'purchaser') {
                    this.$router.replace('/items');
                }
            }
        }
    },
    created: function created() {

        this.user = JSON.parse(this.$cookies.get('teltonika_session_content'));

        if (this.userRole === 'purchaser') {
            //this.$router.replace('/items')
        }
        if (this.userRole === 'client' || this.userRole == 'hq_top') {
            //this.$router.replace('/client/commercial-offers')
        }
        if (this.userRole === 'qc') {
            //this.$router.replace('/auth-commercial-offers')
        }
    },

    methods: {
        getRequest: function getRequest(params) {
            return this.$http.get("https://api-staging.teltonika.hk/api/v1" + params, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session')
                }
            });
        },
        getRequestBlob: function getRequestBlob(params) {
            return this.$http.get("https://api-staging.teltonika.hk/api/v1" + params, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session')
                },
                responseType: 'blob'
            });
        },
        postRequest: function postRequest(params, data) {
            return this.$http.post("https://api-staging.teltonika.hk/api/v1" + params, data, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session')
                }
            });
        },
        putRequest: function putRequest(params, data) {
            return this.$http.put("https://api-staging.teltonika.hk/api/v1" + params, data, {
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session')
                }
            });
        },
        deleteRequest: function deleteRequest(params, data) {
            return this.$http.delete("https://api-staging.teltonika.hk/api/v1" + params, {
                data: data,
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get('teltonika_session')
                }
            });
        },
        isAdmin: function isAdmin() {
            if (this.user) {
                if (this.user.user_type === 'admin') {
                    return true;
                } else {
                    return false;
                }
            }
        },
        isCommercialOffer: function isCommercialOffer() {
            return this.$route.path === 'commercial-offers' ? true : false;
        },
        range: function range(min, max) {
            var array = [],
                j = 0;
            for (var i = min; i <= max; i++) {
                array[j] = i;
                j++;
            }
            return array;
        },
        hasDuplicateAccess: function hasDuplicateAccess() {
            if (this.$root.userRole == 'purchaser') {
                return true;
            }

            if (this.$root.userRole == 'admin') {
                return true;
            }

            if (this.$root.userRole == 'supervisor') {
                return true;
            }

            return false;
        }
    },
    router: router
}).$mount('#app');

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(271),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 40,
	"./af.js": 40,
	"./ar": 47,
	"./ar-dz": 41,
	"./ar-dz.js": 41,
	"./ar-kw": 42,
	"./ar-kw.js": 42,
	"./ar-ly": 43,
	"./ar-ly.js": 43,
	"./ar-ma": 44,
	"./ar-ma.js": 44,
	"./ar-sa": 45,
	"./ar-sa.js": 45,
	"./ar-tn": 46,
	"./ar-tn.js": 46,
	"./ar.js": 47,
	"./az": 48,
	"./az.js": 48,
	"./be": 49,
	"./be.js": 49,
	"./bg": 50,
	"./bg.js": 50,
	"./bn": 51,
	"./bn.js": 51,
	"./bo": 52,
	"./bo.js": 52,
	"./br": 53,
	"./br.js": 53,
	"./bs": 54,
	"./bs.js": 54,
	"./ca": 55,
	"./ca.js": 55,
	"./cs": 56,
	"./cs.js": 56,
	"./cv": 57,
	"./cv.js": 57,
	"./cy": 58,
	"./cy.js": 58,
	"./da": 59,
	"./da.js": 59,
	"./de": 62,
	"./de-at": 60,
	"./de-at.js": 60,
	"./de-ch": 61,
	"./de-ch.js": 61,
	"./de.js": 62,
	"./dv": 63,
	"./dv.js": 63,
	"./el": 64,
	"./el.js": 64,
	"./en-au": 65,
	"./en-au.js": 65,
	"./en-ca": 66,
	"./en-ca.js": 66,
	"./en-gb": 67,
	"./en-gb.js": 67,
	"./en-ie": 68,
	"./en-ie.js": 68,
	"./en-nz": 69,
	"./en-nz.js": 69,
	"./eo": 70,
	"./eo.js": 70,
	"./es": 72,
	"./es-do": 71,
	"./es-do.js": 71,
	"./es.js": 72,
	"./et": 73,
	"./et.js": 73,
	"./eu": 74,
	"./eu.js": 74,
	"./fa": 75,
	"./fa.js": 75,
	"./fi": 76,
	"./fi.js": 76,
	"./fo": 77,
	"./fo.js": 77,
	"./fr": 80,
	"./fr-ca": 78,
	"./fr-ca.js": 78,
	"./fr-ch": 79,
	"./fr-ch.js": 79,
	"./fr.js": 80,
	"./fy": 81,
	"./fy.js": 81,
	"./gd": 82,
	"./gd.js": 82,
	"./gl": 83,
	"./gl.js": 83,
	"./gom-latn": 84,
	"./gom-latn.js": 84,
	"./he": 85,
	"./he.js": 85,
	"./hi": 86,
	"./hi.js": 86,
	"./hr": 87,
	"./hr.js": 87,
	"./hu": 88,
	"./hu.js": 88,
	"./hy-am": 89,
	"./hy-am.js": 89,
	"./id": 90,
	"./id.js": 90,
	"./is": 91,
	"./is.js": 91,
	"./it": 92,
	"./it.js": 92,
	"./ja": 93,
	"./ja.js": 93,
	"./jv": 94,
	"./jv.js": 94,
	"./ka": 95,
	"./ka.js": 95,
	"./kk": 96,
	"./kk.js": 96,
	"./km": 97,
	"./km.js": 97,
	"./kn": 98,
	"./kn.js": 98,
	"./ko": 99,
	"./ko.js": 99,
	"./ky": 100,
	"./ky.js": 100,
	"./lb": 101,
	"./lb.js": 101,
	"./lo": 102,
	"./lo.js": 102,
	"./lt": 103,
	"./lt.js": 103,
	"./lv": 104,
	"./lv.js": 104,
	"./me": 105,
	"./me.js": 105,
	"./mi": 106,
	"./mi.js": 106,
	"./mk": 107,
	"./mk.js": 107,
	"./ml": 108,
	"./ml.js": 108,
	"./mr": 109,
	"./mr.js": 109,
	"./ms": 111,
	"./ms-my": 110,
	"./ms-my.js": 110,
	"./ms.js": 111,
	"./my": 112,
	"./my.js": 112,
	"./nb": 113,
	"./nb.js": 113,
	"./ne": 114,
	"./ne.js": 114,
	"./nl": 116,
	"./nl-be": 115,
	"./nl-be.js": 115,
	"./nl.js": 116,
	"./nn": 117,
	"./nn.js": 117,
	"./pa-in": 118,
	"./pa-in.js": 118,
	"./pl": 119,
	"./pl.js": 119,
	"./pt": 121,
	"./pt-br": 120,
	"./pt-br.js": 120,
	"./pt.js": 121,
	"./ro": 122,
	"./ro.js": 122,
	"./ru": 123,
	"./ru.js": 123,
	"./sd": 124,
	"./sd.js": 124,
	"./se": 125,
	"./se.js": 125,
	"./si": 126,
	"./si.js": 126,
	"./sk": 127,
	"./sk.js": 127,
	"./sl": 128,
	"./sl.js": 128,
	"./sq": 129,
	"./sq.js": 129,
	"./sr": 131,
	"./sr-cyrl": 130,
	"./sr-cyrl.js": 130,
	"./sr.js": 131,
	"./ss": 132,
	"./ss.js": 132,
	"./sv": 133,
	"./sv.js": 133,
	"./sw": 134,
	"./sw.js": 134,
	"./ta": 135,
	"./ta.js": 135,
	"./te": 136,
	"./te.js": 136,
	"./tet": 137,
	"./tet.js": 137,
	"./th": 138,
	"./th.js": 138,
	"./tl-ph": 139,
	"./tl-ph.js": 139,
	"./tlh": 140,
	"./tlh.js": 140,
	"./tr": 141,
	"./tr.js": 141,
	"./tzl": 142,
	"./tzl.js": 142,
	"./tzm": 144,
	"./tzm-latn": 143,
	"./tzm-latn.js": 143,
	"./tzm.js": 144,
	"./uk": 145,
	"./uk.js": 145,
	"./ur": 146,
	"./ur.js": 146,
	"./uz": 148,
	"./uz-latn": 147,
	"./uz-latn.js": 147,
	"./uz.js": 148,
	"./vi": 149,
	"./vi.js": 149,
	"./x-pseudo": 150,
	"./x-pseudo.js": 150,
	"./yo": 151,
	"./yo.js": 151,
	"./zh-cn": 152,
	"./zh-cn.js": 152,
	"./zh-hk": 153,
	"./zh-hk.js": 153,
	"./zh-tw": 154,
	"./zh-tw.js": 154
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 266;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(270),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pending items to order:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pending_items.length),
      expression: "pending_items.length"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readOnly": ""
    },
    domProps: {
      "value": (_vm.pending_items.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pending_items.length = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Vendors for pending items:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pending_vendors.length),
      expression: "pending_vendors.length"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readOnly": ""
    },
    domProps: {
      "value": (_vm.pending_vendors.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pending_vendors.length = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Choose Vendor")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "Select Vendor",
      "label": "name",
      "options": _vm.pending_vendors,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.vendor),
      callback: function($$v) {
        _vm.vendor = $$v
      },
      expression: "vendor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), (_vm.vendor !== null) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    slot: "body"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 pr-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control pull-left",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Search Item"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        _vm.getVendorPendingItems(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v("  \n                                "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.getVendorPendingItems(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 row pl-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Pick a range"
    },
    model: {
      value: (_vm.requested_td_filter),
      callback: function($$v) {
        _vm.requested_td_filter = $$v
      },
      expression: "requested_td_filter"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableRequest1),
      expression: "tableRequest1",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.items,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sales_order.sales_order_number",
      "label": "Sales Order No",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.vendor.name",
      "label": "Vendor",
      "width": "350"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.part_number",
      "label": "Part Number",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "450",
      "label": "Description"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                                    " + _vm._s((scope.row.price_etest_tooling || scope.row.price_setup) ? 'Tooling,setup' : scope.row.quotation.item.description) + "\n                                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "width": "150",
      "label": "QTY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "hq_delivery_date",
      "label": "Requested TD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.direct_shipment) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm.minusDays(scope.row.hq_delivery_date, 14)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        " + _vm._s(_vm.minusDays(scope.row.hq_delivery_date, 7)) + "\n                                    ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Direct Shipment",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.direct_shipment == 1) ? _c('span', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (scope.row.direct_shipment == 0) ? _c('span', [_vm._v("No")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "text-center",
      "label": "Operations",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "btn btn-primary btn-xtra-small",
          attrs: {
            "disabled": _vm.isDisabledAdding(scope.row)
          },
          on: {
            "click": function($event) {
              _vm.addPurchaseItem(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "total": _vm.items_pagination.total,
      "layout": "total, prev, pager, next, sizes",
      "current-page": _vm.items_pagination.current_page,
      "page-size": _vm.itemsLimit,
      "page-sizes": [5, 10, 15, 20, 25, 30, 50]
    },
    on: {
      "current-change": _vm.fetchPaginate,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "items-list"
    }
  }, [_c('br'), _vm._v(" "), _c('p', [_vm._v("Selected Items")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.purchase_order_items,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sales_order.sales_order_number",
      "label": "Sales Order No",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.vendor.name",
      "label": "Vendor",
      "width": "350"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.part_number",
      "label": "Part Number",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "450",
      "prop": "quotation.item.description",
      "label": "Description"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "width": "150",
      "label": "QTY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "class-name": 'bg-light-blue',
      "prop": "hq_delivery_date",
      "label": "Requested TD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.direct_shipment) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.minusDays(scope.row.hq_delivery_date, 14)) + "\n                            ")]) : _c('span', [_vm._v("\n                                " + _vm._s(_vm.minusDays(scope.row.hq_delivery_date, 7)) + "\n                            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Direct Shipment",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.direct_shipment == 1) ? _c('span', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (scope.row.direct_shipment == 0) ? _c('span', [_vm._v("No")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "text-center",
      "label": "Operations",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-xtra-small",
          on: {
            "click": function($event) {
              _vm.removePurchaseItem(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-remove"
        })])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('br'), _vm._v(" "), (_vm.purchase_order_items.length && _vm.vendor !== null) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting
    },
    on: {
      "click": _vm.submitPurchaseOrder
    }
  }, [_vm._v("Submit")]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Requested TD")])])
}]}

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.status == 'selection') ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Select Sales order number",
      "label": "sales_order_number",
      "options": _vm.sales_orders,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.sales_order),
      callback: function($$v) {
        _vm.sales_order = $$v
      },
      expression: "sales_order"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Pick a range"
    },
    model: {
      value: (_vm.unformat_etd_date_range),
      callback: function($$v) {
        _vm.unformat_etd_date_range = $$v
      },
      expression: "unformat_etd_date_range"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Vendors",
      "label": "name",
      "track-by": "name",
      "options": _vm.vendors,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.vendor_filters),
      callback: function($$v) {
        _vm.vendor_filters = $$v
      },
      expression: "vendor_filters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Manufacturers",
      "label": "name",
      "track-by": "name",
      "options": _vm.item_manufacturers,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.item_manufacturer_filters),
      callback: function($$v) {
        _vm.item_manufacturer_filters = $$v
      },
      expression: "item_manufacturer_filters"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Shipping Method",
      "label": "name",
      "track-by": "id",
      "options": _vm.shipping_methods,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.shipping_method),
      callback: function($$v) {
        _vm.shipping_method = $$v
      },
      expression: "shipping_method"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control pull-left",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "Part Number"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": function($event) {
        _vm.getSalesOrderItems(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v("  \n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Select Delivery Code",
      "label": "code",
      "track-by": "id",
      "options": _vm.delivery_codes,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.delivery_code),
      callback: function($$v) {
        _vm.delivery_code = $$v
      },
      expression: "delivery_code"
    }
  })], 1)])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.sales_order_items_all),
      expression: "sales_order_items_all",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sales_order_items,
      "border": "",
      "row-class-name": _vm.statusClass
    },
    on: {
      "sort-change": _vm.sortTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sales_order.sales_order_number",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Sales Order No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sales_order.client_delivery_address.code",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Delivery Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.manufacturer",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Manufacturer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.vendor.name",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Vendor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.part_number",
      "show-overflow-tooltip": true,
      "label": "Part Number",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "width": "150",
      "label": "QTY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETD Vendor",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-vendor",
      "width": "200",
      "sortable": 'custom',
      "prop": "estimated_td_vendor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_vendor != null && scope.row.estimated_td_vendor != '' ? scope.row.estimated_td_vendor : 'Waiting for PO'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETA HK",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-hk",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.direct_shipment) ? _c('span', [_vm._v("\n\t\t                                    " + _vm._s(scope.row.estimated_arrival_date_hk != null && scope.row.estimated_arrival_date_hk != '' ? scope.row.estimated_arrival_date_hk : 'Waiting for PO') + "\n\t\t                                ")]) : _c('span', [_vm._v("\n\t\t                                \tDirect Shipment\n\t\t                                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-td-hk',
      "width": "200",
      "label": "Confirmed TD HK",
      "sortable": 'custom',
      "prop": "estimated_td_date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.direct_shipment) ? _c('div', [_vm._v("Direct Shipment")]) : _c('div', [(!scope.row.estimated_td_date) ? _c('div', [(!scope.row.direct_shipment) ? _c('span', [_vm._v("Pending")]) : _vm._e()]) : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_date))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shipping_method.name",
      "show-overflow-tooltip": true,
      "width": "200",
      "label": "Shipping Method"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-weight',
      "width": "200",
      "label": "Estimated weight, kg"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("currency")((scope.row.quotation.item.weight_grams > 0 ? ((scope.row.quotation.item.weight_grams * scope.row.quantity) / 1000) : ((scope.row.quotation.item.category.average_weight_grams * scope.row.quantity) / 1000)), '', 2, {
          thousandsSeparator: ','
        })))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "text-center",
      "label": "Operations",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "btn btn-primary btn-xtra-small",
          attrs: {
            "disabled": _vm.isAdded(scope.row)
          },
          on: {
            "click": function($event) {
              _vm.addItem(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "total": _vm.pagination.total,
      "layout": "total, prev, pager, next, sizes",
      "current-page": _vm.pagination.current_page,
      "page-size": _vm.limit,
      "page-sizes": [5, 10, 15, 20, 25, 30, 50]
    },
    on: {
      "current-change": _vm.fetchPaginate,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" Selected Items "), _c('br'), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.items,
      "border": "",
      "row-class-name": _vm.statusClass
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sales_order.sales_order_number",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Sales Order No"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sales_order.client_delivery_address.code",
      "show-overflow-tooltip": true,
      "width": "160",
      "label": "Delivery Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.manufacturer",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Manufacturer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.vendor.name",
      "show-overflow-tooltip": true,
      "width": "250",
      "label": "Vendor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quotation.item.part_number",
      "show-overflow-tooltip": true,
      "label": "Part Number",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantity",
      "width": "150",
      "label": "QTY"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETD Vendor",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-vendor",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_vendor != null && scope.row.estimated_td_vendor != '' ? scope.row.estimated_td_vendor : 'Waiting for PO'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ETA HK",
      "show-overflow-tooltip": true,
      "class-name": "estimated-td-hk",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.direct_shipment) ? _c('span', [_vm._v("\n\t\t                                    " + _vm._s(scope.row.estimated_arrival_date_hk != null && scope.row.estimated_arrival_date_hk != '' ? scope.row.estimated_arrival_date_hk : 'Waiting for PO') + "\n\t\t                                ")]) : _c('span', [_vm._v("\n\t\t                                \tDirect Shipment\n\t\t                                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-td-hk',
      "width": "200",
      "label": "Confirmed TD HK"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.estimated_td_date) ? _c('div', [(!scope.row.direct_shipment) ? _c('span', [_vm._v("Pending")]) : _vm._e()]) : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.estimated_td_date))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shipping_method.name",
      "show-overflow-tooltip": true,
      "width": "200",
      "label": "Shipping Method"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": 'col estimated-weight',
      "width": "200",
      "label": "Estimated weight, kg"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("currency")((scope.row.quotation.item.weight_grams > 0 ? ((scope.row.quotation.item.weight_grams * scope.row.quantity) / 1000) : ((scope.row.quotation.item.category.average_weight_grams * scope.row.quantity) / 1000)), '', 2, {
          thousandsSeparator: ','
        })))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "class-name": "text-center",
      "label": "Operations",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-xtra-small",
          on: {
            "click": function($event) {
              _vm.removeItem(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-remove"
        })])]
      }
    }])
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.items.length
    },
    on: {
      "click": function($event) {
        _vm.status = 'contact-sharing'
      }
    }
  }, [_vm._v("Next")])])])]) : _vm._e(), _vm._v(" "), (_vm.status == 'contact-sharing') ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v(_vm._s(_vm.responsible_person.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Select Person",
      "label": "name",
      "options": _vm.contact_options,
      "searchable": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.email_person),
      callback: function($$v) {
        _vm.email_person = $$v
      },
      expression: "email_person"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.addContact()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.contacts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "show-overflow-tooltip": true,
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "show-overflow-tooltip": true,
      "label": "E-mail"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "140",
      "class-name": "text-center",
      "label": "Operations"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "btn btn-danger btn-xtra-small",
          on: {
            "click": function($event) {
              _vm.removeContact(scope.row, scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.status = 'selection'
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('b', [_vm._v("Step 1-4:selection")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Sales Order Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("ETD Vendor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Shipping Method")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "col-form-label"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Delivery Code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', [_c('b', [_vm._v("Step 2-4:Contact Sharing")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Responsible person:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("List of persons to share notifications:")])])
}]}

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-main-container"
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: [_vm.modalSize, _vm.modalType]
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._t("header", [_c('h5', {
    staticStyle: {
      "margin-bottom": "0"
    },
    slot: "header"
  }, [_vm._v("INFORMATION")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body "
  }, [_vm._t("body", [_c('p', [_vm._v("Check Frequently Asked Question for more information.")])]), _vm._v(" "), _vm._t("support", [_vm._v("\n                     Need any help? Please contact support "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("here")]), _vm._v(".\n                  ")])], 2)])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path !== '/login' && _vm.$route.path !== '/otp' && _vm.$route.path !== '/register') ? _c('header', {
    staticClass: "app-header navbar"
  }, [_c('span', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._m(0), _vm._v(" "), (_vm.$root.userRole === 'admin' || _vm.$root.userRole === 'purchaser' || _vm.$root.userRole === 'qc' || _vm.$root.userRole === 'r_and_d' || _vm.$root.userRole === 'client' || _vm.$root.userRole === 'client_p' || _vm.$root.userRole === 'hq_top' || _vm.$root.userRole === 'hq_warehouse') ? _c('span', [(_vm.$root.userRole !== 'client' && _vm.$root.userRole !== 'qc') ? [_c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/backlog"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/backlog.png"
    }
  }), _vm._v(" Backlog\n\t\t                \t")]), _vm._v(" "), (_vm.$root.userRole == 'admin') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "to": "/backlog/sales-order/add"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/cashback.svg"
    }
  }), _vm._v(" New Sales Order\n\t\t                    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'client_p' && _vm.$root.userRole != 'hq_top' && _vm.$root.userRole != 'r_and_d' && _vm.$root.userRole != 'hq_warehouse') ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showPurchaseOrderModal = true
      }
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/bill.png"
    }
  }), _vm._v(" \n\t\t                    \tNew Purchase Order\n\t\t                    ")]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'client_p' && _vm.$root.userRole != 'hq_top' && _vm.$root.userRole != 'r_and_d' && _vm.$root.userRole != 'hq_warehouse') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "to": "/payment-plan/add"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/dollar2.png"
    }
  }), _vm._v(" \n\t\t\t\t\t\t\t\tPayment Plan Submission\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'client_p' && _vm.$root.userRole != 'hq_top' && _vm.$root.userRole != 'r_and_d' && _vm.$root.userRole != 'hq_warehouse') ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "target": "_blank",
      "to": "/arrival-details/add"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/delivery-box.png"
    }
  }), _vm._v(" \n\t\t\t\t\t\t\t\tArrival Details Submission\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$root.user_role == 'admin' || _vm.$root.userRole == 'client_p' || _vm.$root.userRole == 'hq_top') ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showHqDeliveryDateChangeModal = true
      }
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/clock.png"
    }
  }), _vm._v(" \n\t\t                    Change HQ delivery date")]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), (_vm.$root.userRole != 'hq_warehouse') ? _c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/items"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/item.png"
    }
  }), _vm._v(" Items")]), _vm._v(" "), (!_vm.$root.isClient && !_vm.$root.isHqTop && !_vm.$root.isRandD && !_vm.$root.isQc) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/quotations"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/dollar.png"
    }
  }), _vm._v(" Quotations")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/vendors"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/vendor.png"
    }
  }), _vm._v(" Vendors")]), _vm._v(" "), (!_vm.$root.isPurchaser && !_vm.$root.isQc && !_vm.$root.isRandD) ? [(_vm.$root.isClient || _vm.$root.isHqTop) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/client/commercial-offers"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/business.png"
    }
  }), _vm._v(" Commercial Offers")]) : _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/auth-commercial-offers"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/business.png"
    }
  }), _vm._v(" Commercial Offers")])] : _vm._e(), _vm._v(" "), (!_vm.$root.isRandD) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/qr-management"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/quality_assurance.png"
    }
  }), _vm._v(" QR Management")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.$root.userRole === 'admin' || _vm.$root.userRole === 'supervisor' || _vm.$root.userRole === 'client' || _vm.$root.userRole === 'client_p' || _vm.$root.userRole === 'purchaser' || _vm.$root.userRole === 'qc' || _vm.$root.userRole === 'r_and_d' || _vm.$root.userRole === 'hq_top') ? _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/samples-documents"
    }
  }, [_c('img', {
    staticClass: "iconx documentsicon",
    attrs: {
      "src": "/static/images/icons/icon-documents.png"
    }
  }), _vm._v(" Documents/Samples/RFQ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [(_vm.$root.user.user_type === 'admin' || _vm.$root.isHqTop) ? _c('a', {
    staticClass: "nav-link dropdown-toggle nav-link",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "iconx accounticon",
    attrs: {
      "src": "/static/images/icons/icon-system.png"
    }
  }), _vm._v("System")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/users"
    }
  }, [_c('img', {
    staticClass: "iconx usericon",
    attrs: {
      "src": "/static/images/icons/user.png"
    }
  }), _vm._v(" User Management\n\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.$root.anAdmin) ? [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/clients"
    }
  }, [_c('img', {
    staticClass: "iconx usericon",
    attrs: {
      "src": "/static/images/icons/costumer.png"
    }
  }), _vm._v(" Clients")])] : _vm._e(), _vm._v(" "), (_vm.$root.anAdmin) ? [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/settings"
    }
  }, [_c('img', {
    staticClass: "iconx usericon",
    attrs: {
      "src": "/static/images/icons/settings.png"
    }
  }), _vm._v(" Settings")])] : _vm._e()], 2)]), _vm._v(" "), (_vm.$root.anAdmin || _vm.$root.userRole === 'auditor') ? _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/documents-archive"
    }
  }, [_c('img', {
    staticClass: "iconx documentsicon",
    attrs: {
      "src": "/static/images/icons/document-archive.png"
    }
  }), _vm._v(" Documents Archive")])], 1) : _vm._e()], 2) : _c('span', [(_vm.$root.isCommercialOffer()) ? _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/buyersheet"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Buyer Sheet")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.$route.path != '/commercial-offers') ? _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Welcome "), _c('b', [_vm._v(_vm._s(_vm.$root.userName))]), _vm._v("!")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown px-1"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.$root.anAdmin) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/change-password"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Change Password\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/commercial-offers') ? _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_vm._m(4)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPurchaseOrderModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showPurchaseOrderModal = false
      }
    }
  }, [_c('h5', {
    staticStyle: {
      "margin-bottom": "0"
    },
    slot: "header"
  }, [_vm._v("New Purchase Order Registration")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('purchase-order')], 1), _vm._v(" "), _c('span', {
    slot: "support"
  })]) : _vm._e(), _vm._v(" "), (_vm.showHqDeliveryDateChangeModal) ? _c('modal', {
    staticClass: "hq-delivery-date-change",
    on: {
      "close": function($event) {
        _vm.showHqDeliveryDateChangeModal = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "0"
    },
    slot: "header"
  }, [_c('h5', [_c('img', {
    staticClass: "image-50",
    attrs: {
      "src": "/static/images/icons/clock.png"
    }
  }), _vm._v(" "), _c('b', [_vm._v("HQ delivery date change registration")])])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('hq-delivery-date-change')], 1), _vm._v(" "), _c('span', {
    slot: "support"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item dropdown px-1",
    attrs: {
      "id": "hk-logo"
    }
  }, [_c('span', {
    staticClass: "nav-link logo-link",
    staticStyle: {
      "color": "#fff",
      "font-weight": "700",
      "font-style": "italic"
    },
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    staticStyle: {
      "width": "60px",
      "height": "50px"
    },
    attrs: {
      "src": "/static/images/icons/hongkong.png"
    }
  }), _vm._v("\n\t\t    \t\t\t Hong Kong\n\t\t    \t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle active",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "iconx backlogicon",
    attrs: {
      "src": "/static/images/icons/icon-backlog.png"
    }
  }), _vm._v(" Backlog")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle nav-link",
    attrs: {
      "href": "",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "iconx inventoryicon",
    attrs: {
      "src": "/static/images/icons/icon-inventory.png"
    }
  }), _vm._v("Inventory")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link dropdown-toggle nav-link",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_c('i', {
    staticClass: "icon-user icons"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item px-1"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/#login"
    }
  }, [_vm._v("Login")])])
}]}

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [
    [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "form-group",
      class: {
        'has-danger': _vm.errors.has('name')
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.name),
        expression: "name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "name",
        "placeholder": "Add new name"
      },
      domProps: {
        "value": (_vm.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.name = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.errors.first('name')) ? _c('span', {
      staticClass: "error form-control-feedback"
    }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [(_vm.selected.id !== undefined) ? [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitting
      },
      on: {
        "click": _vm.update
      }
    }, [_vm._v("Update")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      attrs: {
        "disabled": _vm.submitting
      },
      on: {
        "click": _vm.cancel
      }
    }, [_vm._v("Cancel")])] : [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitting
      },
      on: {
        "click": _vm.create
      }
    }, [_vm._v("Create")])]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "form-group",
      class: {
        'has-danger': _vm.errors.has('email')
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|email'),
        expression: "'required|email'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.email),
        expression: "email"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "email",
        "name": "email",
        "placeholder": "Add new e-mail"
      },
      domProps: {
        "value": (_vm.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.email = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
      staticClass: "error form-control-feedback"
    }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])])])], _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.search),
        expression: "search"
      }],
      staticClass: "form-control pull-left",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "text",
        "placeholder": "Search Contact"
      },
      domProps: {
        "value": (_vm.search)
      },
      on: {
        "keyup": function($event) {
          _vm.get(1)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.search = $event.target.value
        }
      }
    }), _vm._v("  \n\t                    "), _c('button', {
      staticClass: "btn btn-warning",
      on: {
        "click": function($event) {
          _vm.get(1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-refresh"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading.body",
        value: (_vm.loading),
        expression: "loading",
        modifiers: {
          "body": true
        }
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.contacts,
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "Name",
        "width": "200",
        "show-overflow-tooltip": true
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "email",
        "label": "Email",
        "show-overflow-tooltip": true
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "Operations",
        "width": "150"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('a', {
            staticClass: "btn btn-xs btn-primary btn-xtra-small",
            on: {
              "click": function($event) {
                _vm.edit(scope.row)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-pencil"
          })]), _vm._v(" "), _c('a', {
            staticClass: "btn btn-xs btn-danger btn-xtra-small",
            on: {
              "click": function($event) {
                _vm.remove(scope.row)
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })])]
        }
      }])
    })], 1), _vm._v(" "), _c('el-pagination', {
      attrs: {
        "total": _vm.pagination.total,
        "layout": "total, prev, pager, next, sizes",
        "current-page": _vm.pagination.current_page,
        "page-size": _vm.limit,
        "page-sizes": [5, 10, 15, 20, 25, 30, 50]
      },
      on: {
        "current-change": _vm.fetchPaginate,
        "size-change": _vm.handleSizeChange
      }
    })], 1)])
  ], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  })])
}]}

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[230]);


// WEBPACK FOOTER //
// static/js/app.1e3af061b0950440ebf5.js